export default "__VITE_ASSET__BgZVKznU__"